const cityList = [
    {
        id:0,
        name:'全国'
    },
    {
        id:330300,
        name:'温州'
    },
    {
        id:330100,
        name:'杭州'
    },
    {
        id:310000,
        name:'上海'
    },
    {
        id:320100,
        name:'南京'
    },
    {
        id:440100,
        name:'广州'
    },
    {
        id:440300,
        name:'深圳'
    },
    {
        id:320500,
        name:'苏州'
    },
    {
        id:320581,
        name:'常熟'
    },
    {
        id:320200,
        name:'无锡'
    },
    {
        id:320400,
        name:'常州'
    },
    {
        id:321100,
        name:'镇江'
    },
    {
        id:320600,
        name:'南通'
    },
    {
        id:440400,
        name:'珠海'
    },
    {
        id:120100,
        name:'天津'
    },
    {
        id:411300,
        name:'南阳'
    },
    {
        id:370600,
        name:'烟台'
    }
]
export {cityList};



// WEBPACK FOOTER //
// ./src/datas/city.js